import ApiClient from '../../api/ApiClient';

const apiClient = new ApiClient('campaign_reports', { accountScoped: true, apiVersion: 'v2' });

const state = {
  accountReport: {
    data: [],
  },
  accountSummary: {
    sent_count: 0,
    delivered_count: 0,
    read_count: 0,
    failed_count: 0,
  },
};

const getters = {
  getAccountReports: $state => $state.accountReport,
  getAccountSummary: $state => $state.accountSummary,
};

const actions = {
  fetchAccountSummary: async ({ commit }, params) => {
    try {
      const response = await apiClient.post('summary', params);
      commit('SET_ACCOUNT_SUMMARY', response.data);
    } catch (error) {
      console.error('Failed to fetch campaign summary:', error);
    }
  },

  fetchAccountReport: async ({ commit }, params) => {
    try {
      const response = await apiClient.get('', { params });
      commit('SET_ACCOUNT_REPORTS', { data: response.data.data || [] });
    } catch (error) {
      console.error('Failed to fetch campaign report:', error);
    }
  },
};

const mutations = {
  SET_ACCOUNT_SUMMARY(state, summaryData) {
    state.accountSummary = summaryData;
  },
  SET_ACCOUNT_REPORTS(state, reportData) {
    state.accountReport = reportData;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};